import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDatesStore = defineStore('dates', () => {

    const startDate = ref('');
    const endDate = ref('');

    function updateDate(fieldName, date) {

        if (fieldName === 'startDate') {

            startDate.value = date;

        }

        if (fieldName === 'endDate') {

            endDate.value = date;

        }

    }

    return {
        startDate,
        endDate,
        updateDate,
    }

});
